export default "__VITE_ASSET__BpV4rEwv__"